// extracted by mini-css-extract-plugin
export default {"list":"ProductivityGroupGraph_list__JOv7F"};